import { LeafygreenIconProps } from "../../types";

export const KnownFailure: React.ComponentType<LeafygreenIconProps> = ({
  className,
  fill,
  size = 16,
}) => (
  <svg
    aria-label="Known failure Icon"
    className={className}
    fill="none"
    height={size}
    viewBox="0 0 16 16"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8287 3.75732C10.9994 3.58672 11.2627 3.56511 11.4567 3.69287L11.5358 3.75732L12.2428 4.46436C12.4138 4.63532 12.4347 4.89918 12.3063 5.09326L12.2428 5.17139L9.41467 7.99951L9.76819 8.35303L12.2428 10.8286C12.4134 10.9993 12.435 11.2626 12.3073 11.4565L12.2428 11.5356L11.5358 12.2427C11.365 12.4134 11.1009 12.4351 10.9069 12.3071L10.8287 12.2427L8.35315 9.76807L7.99963 9.41455L5.17151 12.2427C5.00064 12.4134 4.73664 12.4352 4.5426 12.3071L4.46448 12.2427L3.75745 11.5356C3.58663 11.3648 3.56493 11.1008 3.69299 10.9067L3.75745 10.8286L6.23206 8.35303L6.58557 7.99951L3.75745 5.17139C3.5866 5.00051 3.56479 4.73656 3.69299 4.54248L3.75745 4.46436L4.46448 3.75732C4.63533 3.58648 4.89931 3.56475 5.09338 3.69287L5.17151 3.75732L7.99963 6.58545L8.35315 6.23193L10.8287 3.75732Z"
      stroke={fill}
    />
  </svg>
);
